import PropTypes from "prop-types";
import icon_delete from "../../../layout/others/icon_delete.svg";
import { useInterviewContext } from "../InterviewContext";
import { useTranslation } from "react-i18next";
import "../../styles/forms.scss";
import Select from "../../../components/Select";

export default function OtherLanguageSection({
  index,
  onChange,
  otherLanguage,
  languageList,
  languageLevelList,
  deleteAnotherLanguage
}) {
  const { errors, setInterview } = useInterviewContext();
  const { t } = useTranslation();

  const onchangeOtherLanguage = (event, index) => {
    setInterview((prevInterview) => {
      const languageAlreadyExists =
        prevInterview.otherLanguages.some(
          (lang) => lang.language === Number(event.target.value)
        ) || prevInterview.motherLanguageId === Number(event.target.value);

      return {
        ...prevInterview,
        otherLanguages: languageAlreadyExists
          ? prevInterview.otherLanguages
          : prevInterview.otherLanguages.map((lang, i) =>
              i === index
                ? {
                    ...prevInterview.otherLanguages[i],
                    language: Number(event.target.value)
                  }
                : lang
            )
      };
    });
  };

  const onChangeOtherLanguageLevel = (event, index) => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      otherLanguages: prevInterview.otherLanguages.map((lang, i) =>
        i === index
          ? {
              ...prevInterview.otherLanguages[i],
              languageLevel: Number(event.target.value)
            }
          : lang
      )
    }));
  };

  return (
    <div className="row skill-language-width">
      <div className="col-2">
        <div className="form-group">
          {index === 0 && (
            <div className="label-wrapper">
              <label>{t("Language")}</label>
            </div>
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "baseline"
            }}
          >
            {errors.otherLanguages !== undefined &&
              errors.otherLanguages[index] !== undefined &&
              errors.otherLanguages[index].language && (
                <span className="error-msg">
                  {errors.otherLanguages[index].language}
                </span>
              )}
            <Select
              className="form-select"
              onChange={(event) => onchangeOtherLanguage(event, index)}
              value={otherLanguage.language || ""}
              name="language"
              required
              title={t("Selecione um item da lista.")}
            >
              <option key={0} value="" selected disabled>
                {t("Select...")}
              </option>
              {languageList.map((lang) => (
                <option key={lang.id} value={lang.id}>
                  {t(lang.description)}
                </option>
              ))}
            </Select>
          </div>
        </div>
      </div>
      <div className="col-2">
        <div className="row">
          <div className="form-group">
            {index === 0 && (
              <div className="label-wrapper">
                <label>{t("Language level")}</label>
              </div>
            )}
            <div
              className="select-wrapper"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "baseline"
              }}
            >
              {errors.otherLanguages !== undefined &&
                errors.otherLanguages[index] !== undefined &&
                errors.otherLanguages[index].languageLevel && (
                  <span className="error-msg">
                    {errors.otherLanguages[index].languageLevel}
                  </span>
                )}
              <Select
                className="form-select"
                onChange={(event) => onChangeOtherLanguageLevel(event, index)}
                value={otherLanguage.languageLevel || ""}
                name="languageLevel"
                required
                title={t("Selecione um item da lista.")}
              >
                <option key={0} value="" selected disabled>
                  {t("Select...")}
                </option>
                {languageLevelList?.map((langlevel) => (
                  <option key={langlevel.id} value={langlevel.id}>
                    {t(langlevel.description)}
                  </option>
                ))}
              </Select>
            </div>
          </div>
        </div>
      </div>
      <div className="col">
        {index >= 0 && (
          <button
            type="button"
            className="app-button btn-second btn-md"
            onClick={() => deleteAnotherLanguage(index)}
            style={index === 0 ? { marginTop: "25px" } : { marginTop: "0px" }}
          >
            <img src={icon_delete} alt="delete" width="12px" height="auto" />{" "}
            {t("Delete")}
          </button>
        )}
      </div>
    </div>
  );
}

OtherLanguageSection.propTypes = {
  index: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  otherLanguage: PropTypes.object.isRequired,
  languageList: PropTypes.array.isRequired,
  languageLevelList: PropTypes.array.isRequired,
  deleteAnotherLanguage: PropTypes.func.isRequired
};
